var Utils = require('../lib/utils');

module.exports = {

    getMovieclipTimeline: function(movieclips, opts)
    {
        opts = _.merge({
            repeat: -1,
            repeatDelay: 0,
            fps: 4,
            ease: Linear.easeNone,
            onFrameUpdate: null
        }, opts);

        movieclips = _.isArray(movieclips) ? movieclips:[movieclips];

        var timeline = new TimelineMax();

        movieclips.map(function(movieclip){
            var frameParams = {
                frame: 0
            };
            timeline.to(frameParams, movieclip.totalFrames/opts.fps, _.extend(_.omit(opts, ['onFrameUpdate', 'fps']), {
                frame: movieclip.totalFrames,
                onUpdate: Utils.updateMovieclipParams,
                onUpdateParams: [
                    movieclip,
                    frameParams,
                    opts.onFrameUpdate
                ]
            }), 0);
        });

        return timeline;
    }
};



// WEBPACK FOOTER //
// ./js/animations/common.js